import styled from 'styled-components';

const OverflowContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export default OverflowContainer;
